import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsPageComponent } from './about-us/about-us-page/about-us-page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UploadTabComponent } from '../../src/app/patients/dashboard-page/upload-tab/upload-tab.component';

// Import canActivate guards
import { PATH_ABOUT_US, PATH_PAGE_NOT_FOUND, PATH_UPLOAD } from './global';
import { PATH_LOGIN } from './login/login.global';

export const appRoutes: Routes = [
  { path: '', redirectTo: PATH_LOGIN, pathMatch: 'full' },
  { path: PATH_ABOUT_US, component: AboutUsPageComponent },
  { path: PATH_PAGE_NOT_FOUND, component: PageNotFoundComponent },
  { path: PATH_UPLOAD, component: UploadTabComponent },
  { path: '**', redirectTo: PATH_PAGE_NOT_FOUND },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
